import { render, staticRenderFns } from "./AnimatedRegion.vue?vue&type=template&id=2cb3b757&scoped=true&"
import script from "./AnimatedRegion.vue?vue&type=script&lang=js&"
export * from "./AnimatedRegion.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedRegion.vue?vue&type=style&index=0&id=2cb3b757&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb3b757",
  null
  
)

export default component.exports